// Use dynamic import here to allow webpack to interface with module federation code.
// This is important in order to avoid "Shared module is not available for eager consumption" errors.
import('./app');
